import type { RoleGatewayState } from '../contexts/AuthContext';

type ClerkUserUpdater = {
  update?: (payload: { unsafeMetadata?: Record<string, unknown> }) => Promise<unknown> | unknown;
};

declare global {
  interface Window {
    Clerk?: {
      user?: ClerkUserUpdater;
    };
  }
}

export async function syncClerkRoleMetadata(roleGateway: RoleGatewayState): Promise<boolean> {
  const updater = window.Clerk?.user?.update;
  if (!updater) return false;

  await updater({
    unsafeMetadata: {
      roleGateway,
      syncedAt: new Date().toISOString(),
    },
  });

  return true;
}
